import React from 'react';
import content from './content.json';
import { fmtDate } from './Layout';

export function LogEntry({ entry }) {
  const title = entry.link
    ? <a href={entry.link} target="_blank" rel="noopener noreferrer" className="hover:underline underline-offset-4">{entry.title} <span className="ibl-faint">↗</span></a>
    : entry.title;
  return (
    <article className="grid gap-3 md:grid-cols-[180px_1fr] py-7 border-t ibl-line">
      <div className="ibl-mono text-[10px] ibl-muted leading-relaxed">
        <time dateTime={entry.date}>{fmtDate(entry.date)}</time>
      </div>
      <div className="max-w-2xl">
        <div className="flex flex-wrap items-center gap-3 mb-2">
          <h3 className="text-[19px] font-medium tracking-[-0.01em] leading-snug">{title}</h3>
          {entry.tag && <span className="ibl-chip">{entry.tag}</span>}
          {entry.source && <span className="ibl-mono text-[10px] ibl-faint">via {entry.source}</span>}
        </div>
        <div className="ibl-feed text-[15px] leading-relaxed ibl-muted" dangerouslySetInnerHTML={{ __html: entry.html }} />
      </div>
    </article>
  );
}

export default function Log() {
  const { news } = content;
  return (
    <section className="mx-auto max-w-6xl px-6 pt-20 pb-10">
      <p className="ibl-mono ibl-muted mb-5">Log</p>
      <h1 className="text-[40px] sm:text-[56px] font-medium tracking-[-0.035em] leading-[1] max-w-3xl">
        What we read, built, <span className="ibl-faint">and broke.</span>
      </h1>
      <p className="mt-6 max-w-xl text-[17px] ibl-muted leading-relaxed">
        Short entries, every few days. Lab updates, papers worth the time, news from the field. Newest first.
      </p>
      <div className="mt-14 border-b ibl-line">
        {news.map((e) => <LogEntry key={e.date + e.slug} entry={e} />)}
      </div>
    </section>
  );
}
